import GetStarted from "components/Sections/GetStarted";
import Hero from "./Hero";
import Locations from "components/Sections/Locations";
import LocationList from "./LocationList";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { fetchLocationsPage, selectLocationsPageCTA, selectLocationsPageIsLoading, selectLocationsPageLocations } from "store/slices/LocationsSlice";
import LocationWorldMap from "./InteractiveMap/WorldMap";
import { useImageLoaded } from "hooks/useImageLoaded";

const MainProxyLocation = () => {
    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(true);

    const locationsText = useSelector(selectLocationsPageLocations)
    const cta = useSelector(selectLocationsPageCTA)

    const isLocationsPageLoading = useSelector(selectLocationsPageIsLoading)
    const isLoadedImages = useImageLoaded(null, selectLocationsPageIsLoading);


    useEffect(() => {
        // @ts-ignore
        dispatch(fetchLocationsPage())
    }, [dispatch])

    useEffect(() => {
        if (isLoadedImages && !isLocationsPageLoading) {
            setIsLoading(false)
        }
    }, [isLoadedImages, isLocationsPageLoading]);

    return !isLocationsPageLoading && (
        <>
            <Hero />
            <LocationWorldMap isLoading={isLoading} />
            <Locations locationsText={locationsText} isLoading={isLoading} />
            <LocationList isLoading={isLoading} />
            <GetStarted cta={cta} isLoading={isLoading} />
        </>
    );
}

export default MainProxyLocation;